import type { Choice } from '../../types'
import Icon from '../Common/Icon'

interface ChoiceButtonsProps {
  choices: Choice[]
  onSelect: (index: number) => void
  disabled?: boolean
  selectedIndex?: number | null
}

function ChoiceButtons({ choices, onSelect, disabled, selectedIndex }: ChoiceButtonsProps) {
  if (choices.length === 0) return null

  return (
    <div className="space-y-2 mt-3">
      <div className="font-pixel text-[9px] text-[color:var(--color-text-dim)] mb-1 tracking-wider">
        ► 选择你的动作
      </div>
      {choices.map((choice, index) => {
        const isSelected = selectedIndex === index
        const isCorrect = choice.isCorrect
        const hasAnswered = selectedIndex !== null && selectedIndex !== undefined

        // 状态决定样式
        let boxClass = 'pixel-box p-2.5 cursor-pointer transition-all pixel-box-hover'
        const letter = String.fromCharCode(65 + index) // A, B, C, D
        let letterColor = 'var(--color-gold)'

        if (!hasAnswered) {
          boxClass += ' hover:translate-x-[-1px] hover:translate-y-[-1px] active:scale-[0.99]'
        } else if (isSelected) {
          if (isCorrect) {
            boxClass = 'pixel-box p-2.5 border-[color:var(--color-bull)] bg-[color:var(--color-bg-elevated)] choice-correct-anim'
            letterColor = 'var(--color-bull)'
          } else {
            boxClass = 'pixel-box p-2.5 border-[color:var(--color-bear)] bg-[color:var(--color-bg-elevated)] choice-wrong-anim'
            letterColor = 'var(--color-bear)'
          }
        } else {
          boxClass += ' opacity-50'
        }

        return (
          <button
            key={index}
            onClick={() => !hasAnswered && onSelect(index)}
            disabled={disabled || hasAnswered}
            className={boxClass + ' w-full text-left'}
          >
            <div className="flex items-start gap-2">
              {/* 选项字母标识 */}
              <span
                className="font-pixel text-base w-6 flex-shrink-0 mt-0.5"
                style={{ color: letterColor }}
              >
                {letter}
              </span>

              <div className="flex-1">
                <div className="font-pixel-body text-sm text-[color:var(--color-text-bright)] leading-snug">
                  {choice.text}
                </div>
                {hasAnswered && isSelected && (
                  <div
                    className="mt-1 font-pixel-body text-xs leading-snug"
                    style={{ color: isCorrect ? 'var(--color-bull)' : 'var(--color-bear)' }}
                  >
                    ► {choice.feedback}
                  </div>
                )}
                {hasAnswered && !isSelected && (
                  <div className="mt-1 font-pixel-body text-xs text-[color:var(--color-text-dim)] leading-snug">
                    {choice.feedback}
                  </div>
                )}
              </div>

              {hasAnswered && isSelected && (
                <span
                  className="flex-shrink-0 mt-0.5"
                  style={{ color: letterColor }}
                >
                  <Icon name={isCorrect ? 'check' : 'cross'} size={14} />
                </span>
              )}
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default ChoiceButtons